// 예제는 {en, ko} 두 벌이다. 코드는 같고 **주석만 언어가 다르다**.
// 고르는 곳은 pythoncode-tab.jsx 의 insertExampleCode (현재 로케일 사용, ko 외에는 en 폴백).
// 문자열 하나만 있는 예제는 그대로 둬도 동작한다 — 그럴 땐 모든 언어가 그 문자열을 본다.
export const DcMotor01Example = {
    ko: `
# ── 모터 1개로 오른쪽·왼쪽 번갈아 돌리기 ──
# def 는 "명령 묶음에 이름을 붙이는 것"입니다.
# 아래에서 이름만 부르면 그 묶음이 실행돼요.

def turn_right():          # '오른쪽으로' 라는 이름의 명령 묶음
    turn_dcmotor1("RIGHT")  # 1번 모터를 오른쪽으로 돌린다
    sleep(1)                # 1초 기다린다 (안 쓰면 눈에 안 보이게 지나갑니다)

def turn_left():
    turn_dcmotor1("LEFT")   # 왼쪽으로
    sleep(1)

def turn_off():
    turn_dcmotor1("STOP")   # 멈춤
    sleep(1)

# 여기부터 실제로 실행됩니다. 순서대로 한 줄씩 내려가요.
turn_right()
turn_off()
turn_left()
turn_off()`,
    en: `
# ── One motor: turn right, then left ──
# "def" gives a name to a group of commands.
# Calling that name below runs the whole group.

def turn_right():           # a group of commands named 'turn_right'
    turn_dcmotor1("RIGHT")  # turn motor 1 to the right
    sleep(1)                # wait 1 second (without this it flashes by too fast to see)

def turn_left():
    turn_dcmotor1("LEFT")   # to the left
    sleep(1)

def turn_off():
    turn_dcmotor1("STOP")   # stop
    sleep(1)

# This is where it actually starts running, one line at a time.
turn_right()
turn_off()
turn_left()
turn_off()`
};

const DcMotor02Body = `
def turn_left():
    turn_dcmotor1("LEFT")
    turn_dcmotor2("LEFT")
    sleep(1.5)

def stop():
    turn_dcmotor1("STOP")
    turn_dcmotor2("STOP")
    sleep(1)

async def play():
    forward()
    stop()
    turn_left()
    stop()
    forward()
    stop()
    turn_left()
    stop()
    forward()
    stop()
    turn_left()
    stop()
    forward()
    stop()
    turn_left()
    stop()

play()`;

// 앞부분(설명 주석 + forward 정의)만 언어별로 다르고, 나머지 코드는 공통이다.
export const DcMotor02Example = {
    ko: `
# ── 모터 2개로 자동차처럼 움직이기 ──
# 바퀴가 마주 보고 달려 있어서, 앞으로 가려면 한쪽은 RIGHT 다른 쪽은 LEFT 입니다.
# 두 바퀴를 같은 방향으로 돌리면 제자리에서 회전해요.

def forward():             # 앞으로
    turn_dcmotor1("RIGHT")
    turn_dcmotor2("LEFT")
    sleep(3)               # 3초 동안 앞으로. 숫자를 바꾸면 더 멀리 갑니다
${DcMotor02Body}`,
    en: `
# ── Two motors: drive it like a car ──
# The wheels face each other, so going forward means one RIGHT and one LEFT.
# Turning both the same way spins the robot in place.

def forward():
    turn_dcmotor1("RIGHT")
    turn_dcmotor2("LEFT")
    sleep(3)               # forward for 3 seconds. Change the number to go further
${DcMotor02Body}`
};

const LedBody = `
# ffffffffffffffff, 0000000000000000, 0038444444380000
async def display_set():
    display_set_pixel("0000000000000000")
    sleep(0.1)
    display_set_pixel("00000000000000ff")
    sleep(0.1)
    display_set_pixel("000000000000ffff")
    sleep(0.1)
    display_set_pixel("0000000000ffffff")
    sleep(0.1)
    display_set_pixel("00000000ffffffff")
    sleep(0.1)
    display_set_pixel("000000ffffffffff")
    sleep(0.1)
    display_set_pixel("0000ffffffffffff")
    sleep(0.1)
    display_set_pixel("00ffffffffffffff")
    sleep(0.1)
    display_set_pixel("ffffffffffffffff")
    sleep(0.1)

# 1, 2, 3, 4, 5, 6, 7, 8, 9, 0
async def display_number():
    display_show("2")
    sleep(1)
    display_show("9")
    sleep(1)

# A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z
async def display_alphabet():
    display_show("B")
    sleep(1)
    display_show("Y")
    sleep(1)

'''
SMILE1, SMILE2, SMILE3, SMILE4, HAPPY, CRY, ANGRY, SAD, SUN, MOON, SQUARE, CIRCLE, TRIANGLE,
FLOWER, HEART, 8ANGLES, EXCLAMATION, QUESTION, STAR, MINUS, PLUS, MULTIPLY, DIVISION, DURK,
NOTE1, NOTE2, O, X, FULL, FORWARD, BACKWARD, RIGHT, LEFT, CLEAR
'''
async def display_shape():
    display_show("SMILE2")
    sleep(1)
    display_show("LEFT")
    sleep(1)
        
async def main():
    display_set()
    display_number()
    display_alphabet()
    display_shape()

main()`;

export const LedBlockExample = {
    ko: `
# ── LED 8×8 점판에 그림·숫자·글자 띄우기 ──
# 아래 네 가지를 차례로 보여줍니다: 아래에서 위로 채우기 → 숫자 → 알파벳 → 그림
# display_set_pixel 은 64개 점을 16자리 숫자로 나타냅니다(한 자리가 4개 점).
# 아래 줄은 그 예시 값이에요. 그대로 복사해 써 보세요.${LedBody}`,
    en: `
# ── Show pictures, numbers and letters on the 8×8 LED grid ──
# Four things run in order: fill from the bottom → numbers → letters → shapes
# display_set_pixel describes all 64 dots with 16 digits (one digit = 4 dots).
# The line below holds example values. Copy one and try it.${LedBody}`
};

const MasterBody = `
# #ff0000, #00ff00, #0000ff, #ffffff, #ffff00, #00ffff, #ff00ff, #000000
async def turn_on_light_set():
    turnon_colorlight("#00ff00")
    sleep(1)
    turnon_colorlight("#000000")
    sleep(1)

# RED, ORANGE, YELLOW, GREEN, BLUE, PURPLE, WHITE
async def turn_on_light():
    turnon_colorlight_show("RED")
    sleep(1)
    turnon_colorlight_show("WHITE")
    sleep(1)

async def main():
    turn_on_light_set()
    turn_on_light()

main()`;

export const MasterBlockExample = {
    ko: `
# ── 마스터 블록 색깔 불 켜기 ──
# 색을 정하는 방법이 두 가지입니다.
#   turnon_colorlight("#00ff00")     → 색 코드로 직접 (빨강/초록/파랑을 섞는 방식)
#   turnon_colorlight_show("RED")    → 정해진 이름으로 (쉬움)
# "#000000" 은 검정 = 불 끄기 입니다.${MasterBody}`,
    en: `
# ── Turn on the colour light of the master block ──
# There are two ways to choose a colour.
#   turnon_colorlight("#00ff00")     → a colour code (mixing red / green / blue)
#   turnon_colorlight_show("RED")    → a ready-made name (easier)
# "#000000" is black, which means the light is off.${MasterBody}`
};

const SoundBody = `
# DO_48, DO_49, RE_50, MI_51, MI_52, FA_53, FA_54, SOL_55, SOL_56, RA_57, SI_58, SI_59,
# DO_60, DO_61, RE_62, MI_63, MI_64, FA_65, FA_66, SOL_67, SOL_68, RA_69, SI_70, SI_71
# DO_72, RE_74, MI_76, FA_77, SOL_79, RA_81, SI_83, DO_84
async def play_sound():
    play_note("DO_60")
    sleep(0.5)
    play_note("RE_62")
    sleep(0.5)
    play_note("MI_64")
    sleep(0.5)
    play_note("FA_65")
    sleep(0.5)
    play_note("SOL_67")
    sleep(0.5)
    play_note("RA_69")
    sleep(0.5)
    play_note("SI_71")
    sleep(0.5)
    play_note("DO_72")
    sleep(0.5)
    play_note_time("DO_84", 3)
    sleep(1)

# ERROR, SMALL_EFFECT, WARNING, LIGHT, BASIC, GREAT_EFFECT
async def play_effect():
    play_note("ERROR")
    sleep(1)
    play_note_time("GREAT_EFFECT", 3)
    sleep(1)

async def main():
    play_sound()
    play_effect()

main()
`;

export const SountBlockExample = {
    ko: `
# ── 사운드 블록으로 음 연주하기 ──
# 음 이름은 "계이름_숫자" 입니다. 숫자가 클수록 높은 음이에요.
# DO_60 이 가운데 도(피아노 한가운데). DO_72 는 한 옥타브 위입니다.
# sleep 으로 음의 길이를 정합니다 — 0.5 는 짧게, 1 은 길게.${SoundBody}`,
    en: `
# ── Play notes with the sound block ──
# A note name is "note_number". The bigger the number, the higher the note.
# DO_60 is middle C. DO_72 is one octave above it.
# sleep decides how long a note lasts — 0.5 is short, 1 is long.${SoundBody}`
};

const ProximityBody = `
n = 0

while n <10:
    if is_obstacle_detected():
        turn_dcmotor1("STOP")
        turn_dcmotor2("STOP")
        sleep(0.1)
        turn_dcmotor1("RIGHT")
        turn_dcmotor2("LEFT")
        sleep(1)
        turn_dcmotor1("RIGHT")
        turn_dcmotor2("RIGHT")
        sleep(1.5)
        turn_dcmotor1("STOP")
        turn_dcmotor2("STOP")
        sleep(1)
    else:
        turn_dcmotor1("LEFT")
        turn_dcmotor2("RIGHT")
        sleep(0.1)
        turn_dcmotor1("STOP")
        turn_dcmotor2("STOP")
        sleep(0.1)
    n =n +1`;

export const ProximitySensorExample = {
    ko: `
# ── 자율주행 자동차 ── (Self-Driving Car)
# 앞에 뭔가 있으면 피해서 돌아가고, 없으면 계속 앞으로 갑니다.
# while = "조건이 맞는 동안 계속 반복"  /  if~else = "이러면 A, 아니면 B"
# n 은 몇 번 반복했는지 세는 상자입니다.${ProximityBody}`,
    en: `
# ── Self-Driving Car ──
# If something is in front, it steers around it; otherwise it keeps going.
# while = "repeat while the condition holds"  /  if~else = "if this do A, otherwise B"
# n is a box that counts how many times it has repeated.${ProximityBody}`
};

const LightNTouchBody = `
async def main():
    for x in range(10):
        n = get_brigtness()
        if  n < 500:
            print(n, "Brigtness")
            turnon_colorlight_show("WHITE")
            print(x, "Number")
            sleep(0.1)
        else:
            print(n, "Brigtness")
            turnoff_colorlight()
            print(x, "Number")
            sleep(0.1)

main()`;

export const LightNTouchSensorBlockExample = {
    ko: `
# ── 스마트 가로등 ── (Smart Street Lighting)
# 어두워지면 불이 켜지고, 밝아지면 꺼지는 진짜 가로등처럼 동작합니다.
# get_brigtness() 가 주변 밝기를 숫자로 알려줘요. 작을수록 어둡습니다.
# 500 이 기준값입니다 — 교실이 밝으면 숫자를 올려서 실험해 보세요.${LightNTouchBody}`,
    en: `
# ── Smart Street Lighting ──
# The light turns on when it gets dark and off when it gets bright, like a real street lamp.
# get_brigtness() reports the surrounding brightness as a number. Smaller means darker.
# 500 is the threshold — if your classroom is bright, raise it and try again.${LightNTouchBody}`
};

const FlashlightBody = `
async def main():
    for x in range(1, 10):
        if is_button_pressed():
            turnon_colorlight_show("WHITE")
            print(x, "True")
            sleep(0.1)
        else:
            turnoff_colorlight()
            print(x, "False")
            sleep(0.1)

main()`;

export const LightNTouchSensorBlockExample02 = {
    ko: `
# ── 손전등 ── (Flashlight)
# 버튼을 누르고 있는 동안만 불이 켜집니다.
# is_button_pressed() 는 눌렸으면 True, 아니면 False 를 돌려줘요.${FlashlightBody}`,
    en: `
# ── Flashlight ──
# The light stays on only while the button is held down.
# is_button_pressed() returns True when pressed and False when not.${FlashlightBody}`
};

export const ExtensionExample =
`
# Programming - Random Numbers

async def main():
    while True:
        display_show("CLEAR")
        x = randint(1, 6)
        print(x, "Number")
        sleep(0.1)
        if is_button_pressed():
            display_show(x)
            print(x, "Number")
            break

main()
`;

// ---- 🐍 Python 3 (real CPython · pandas · Data Chart) examples ----
// NOTE: run these with the [ 🐍 Python 3 ] button, not [ ▶ Run ](jspython).

export const RealPythonExample =
`
# Real Python 3.14  —  run with the [ Python 3 ] button!
# (things jspython [ Run ] could not do)

# Big numbers, exactly
print("2 ** 100 =", 2 ** 100)

# Loops + lists
squares = [x ** 2 for x in range(1, 11)]
print("squares 1-10:", squares)

# Libraries
import math
print("20! =", math.factorial(20))
print("pi =", round(math.pi, 5))
`;

export const PandasExample =
`
# pandas = real data-analysis library  —  run with [ Python 3 ]!
import pandas as pd

# Make a table (DataFrame)
df = pd.DataFrame({
    "fruit": ["apple", "banana", "grape", "strawberry"],
    "count": [5, 3, 8, 6]
})
print(df)

# Statistics
print("sum:", df["count"].sum())
print("mean:", df["count"].mean())
print("most common:", df.loc[df["count"].idxmax(), "fruit"])
`;

export const ChartExample =
`
# Draw Python data with the Data Chart!  —  run with [ Python 3 ]
# * First add the "Data Chart" extension from the [ Code ] tab.
import pandas as pd

df = pd.DataFrame({
    "fruit": ["apple", "banana", "grape", "strawberry"],
    "count": [5, 3, 8, 6]
})

chart(df["fruit"], df["count"])            # bar chart
# chart(df["fruit"], df["count"], "line")  # line chart
# chart(df["fruit"], df["count"], "pie")   # pie chart
`;

// ============================================================
//  Leveled Projects  —  each topic GROWS Lv1 -> Lv2 -> Lv3
//  (2026-07-03, plan: docs/ANALYSIS_leveled_examples_2026-07-02.md)
// ============================================================

// ---- 🤖 Track A · Robot Car  (Run with the [ Run ] button) ----

export const RobotCarLv1Example =
`
# Lv1 · Robot Car — move ONE wheel
# Run with the [ Run ] button (Smart Blocks).

turn_dcmotor1("RIGHT")   # start the wheel (forward)
sleep(1)                 # keep going for 1 second
turn_dcmotor1("STOP")    # stop
`;

export const RobotCarLv2Example =
`
# Lv2 · Robot Car — drive with TWO wheels
# We wrap Lv1's idea into functions we can reuse.

def forward():
    turn_dcmotor1("RIGHT")
    turn_dcmotor2("LEFT")
    sleep(1)

def turn():
    turn_dcmotor1("RIGHT")
    turn_dcmotor2("RIGHT")
    sleep(0.6)

def stop():
    turn_dcmotor1("STOP")
    turn_dcmotor2("STOP")

forward()
turn()
forward()
stop()
`;

export const RobotCarLv3Example =
`
# Lv3 · Robot Car — drive by ITSELF using the sensor
# Same moves as Lv2, but now the robot decides when to turn.

for i in range(20):
    if is_obstacle_detected():
        # obstacle ahead -> turn away
        turn_dcmotor1("RIGHT")
        turn_dcmotor2("RIGHT")
        sleep(0.6)
    else:
        # clear -> go forward
        turn_dcmotor1("RIGHT")
        turn_dcmotor2("LEFT")
        sleep(0.2)

turn_dcmotor1("STOP")
turn_dcmotor2("STOP")
`;

// ---- 🤖 Track B · Light & Sound  (Run with the [ Run ] button) ----

export const LightSoundLv1Example =
`
# Lv1 · Light & Sound — show a face and play notes
# Run with the [ Run ] button (Smart Blocks).

display_show("SMILE2")
sleep(1)

play_note("DO_60")
sleep(0.4)
play_note("MI_64")
sleep(0.4)
play_note("SOL_67")
sleep(0.4)

display_clear()
`;

export const LightSoundLv2Example =
`
# Lv2 · Traffic Light — colors in order, with a beep
# We put "show a color for N seconds" into one function.

def light(color, secs):
    turnon_colorlight_show(color)
    sleep(secs)

light("GREEN", 2)
light("YELLOW", 1)
play_note("WARNING")     # beep before red
sleep(0.5)
light("RED", 2)

turnoff_colorlight()
`;

export const LightSoundLv3Example =
`
# Lv3 · Smart Streetlight — the light reacts to darkness
# Uses the brightness sensor to switch the LED on/off.

for i in range(15):
    if get_brigtness() < 500:      # dark -> turn on
        turnon_colorlight_show("WHITE")
    else:                          # bright -> turn off
        turnoff_colorlight()
    sleep(0.2)

turnoff_colorlight()
`;

// ---- 📊 Track C · Score Analysis  (Run with the [ Python 3 ] button) ----

export const ScoreLv1Example =
`
# Lv1 · Score Table — make data and see the basics
# Run with the [ Python 3 ] button.
import pandas as pd

df = pd.DataFrame({
    "name":  ["Ann", "Ben", "Cara", "Dan"],
    "score": [88, 72, 95, 60]
})
print(df)

print("mean:", df["score"].mean())
print("top student:", df.loc[df["score"].idxmax(), "name"])
`;

export const ScoreLv2Example =
`
# Lv2 · Analyze — filter, sort, and draw a chart
# Add the "Data Chart" extension first (Code tab) for chart().
import pandas as pd

df = pd.DataFrame({
    "name":  ["Ann", "Ben", "Cara", "Dan"],
    "score": [88, 72, 95, 60]
})

passed = df[df["score"] >= 80]              # 80 and above
print("passed:", passed["name"].tolist())

top3 = df.sort_values("score", ascending=False).head(3)
chart(top3["name"], top3["score"])          # bar chart of top 3
`;

export const ScoreLv3Example =
`
# Lv3 · Relationship — do more study hours mean higher scores?
import pandas as pd

df = pd.DataFrame({
    "hours": [1, 2, 3, 4, 5, 6],
    "score": [55, 60, 70, 75, 88, 95]
})

r = df["hours"].corr(df["score"])           # -1 ~ 1
print("correlation:", round(r, 2))
chart(df["hours"], df["score"], "line")     # see the trend
`;

// ---- 📊 Track D · My Money  (Run with the [ Python 3 ] button) ----

export const MoneyLv1Example =
`
# Lv1 · Allowance — total and biggest spending
# Run with the [ Python 3 ] button.
import pandas as pd

df = pd.DataFrame({
    "item": ["snack", "book", "game", "bus"],
    "won":  [3000, 8000, 12000, 1500]
})
print(df)

print("total:", df["won"].sum())
print("most spent on:", df.loc[df["won"].idxmax(), "item"])
`;

export const MoneyLv2Example =
`
# Lv2 · Where does my money go? — a pie chart
# Add the "Data Chart" extension first (Code tab) for chart().
import pandas as pd

df = pd.DataFrame({
    "item": ["snack", "book", "game", "bus"],
    "won":  [3000, 8000, 12000, 1500]
})
df = df.sort_values("won", ascending=False)

chart(df["item"], df["won"], "pie")
`;

export const MoneyLv3Example =
`
# Lv3 · By Category — group items and compare totals
import pandas as pd

df = pd.DataFrame({
    "category": ["food", "food", "fun", "fun", "transport"],
    "won":      [3000, 2000, 12000, 5000, 1500]
})

by_cat = df.groupby("category")["won"].sum()
print(by_cat)
chart(by_cat.index.tolist(), by_cat.tolist())   # total per category
`;
